import Card from 'components/card/Card';
import { black } from 'modules/colors';
import media from 'modules/media';
import { fonts, spacing } from 'modules/metrics';
import styled from 'styled-components';

export const CardStyled = styled(Card)`
  color: ${black};
  padding: ${spacing.md}px;
  align-items: center;
  ${(props) =>
    props.onClick && ':hover { box-shadow: 0 5px 15px rgb(97, 118, 160); }'}

  ${media.tablet} {
    margin-top: ${spacing.xl}px;
  }
`;

export const Row = styled.div`
  display: flex;
  font-size: ${fonts.sm}px;
  align-items: center;
  font-size: ${fonts.md}px;
`;

export const DetailTitle = styled.div`
  margin-right: ${spacing.sm}px;
  display: flex;
  align-items: center;
  white-space: nowrap;

  > img {
    margin-right: ${spacing.sm}px;
  }
`;

export const DetailText = styled.div`
  font-weight: 500;
`;
